export const DEFAULT_API_TIMEOUT_MS = 15000;

export async function apiFetch(input, init = {}, timeoutMs = DEFAULT_API_TIMEOUT_MS) {
  const controller = new AbortController();
  const sourceSignal = init.signal;
  const abortFromSource = () => controller.abort(sourceSignal?.reason);

  if (sourceSignal?.aborted) abortFromSource();
  else sourceSignal?.addEventListener('abort', abortFromSource, { once: true });

  const timer = window.setTimeout(() => {
    controller.abort(new DOMException('API request timeout', 'TimeoutError'));
  }, timeoutMs);

  try {
    return await fetch(input, { ...init, signal: controller.signal });
  } finally {
    window.clearTimeout(timer);
    sourceSignal?.removeEventListener('abort', abortFromSource);
  }
}

export async function apiJson(input, init = {}, timeoutMs) {
  const response = await apiFetch(input, init, timeoutMs);
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(data.message || `HTTP ${response.status}`);
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
}
